import React from "react";
import Home from "./components/Home";
import Footer from "./components/Footer";
import Header from "./components/Header";
import { createTheme, ThemeProvider } from "@mui/material";
import { themeOptions } from "./components/theme";
import { Routes, Route, useParams } from "react-router-dom";
import { About } from "./components/About";
import { Contact } from "./components/Contact";
import { Blog, blogPosts } from "./components/Blog";
import { init } from "@emailjs/browser";
import { Grid2 as Grid } from "@mui/material";

const BlogPost: React.FC = () => {
  const { id } = useParams();
  const post = blogPosts.find(post => post.id === id);
  
  if (!post) {
    return (
      <Grid container m={1} mb={20}>
        <Header />
        <Grid size={12} mt={5}>
          <div>Blog post not found</div>
        </Grid>
      </Grid>
    );
  }
  
  const PostComponent = post.component;
  return (
    <Grid container m={1} mb={20}>
      <Header />
      <Grid size={12} mt={5}>
        <PostComponent />
      </Grid>
    </Grid>
  );
};

const App: React.FC = () => {
  const theme = createTheme(themeOptions);
  init({ publicKey: "h90uGO475br5bIj8R" });

  return (
    <ThemeProvider theme={theme}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route index element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogPost />} />
      </Routes>
      {/* <Home /> */}
      <Footer />
    </ThemeProvider>
  );
};

export default App;
